import React, { useState } from 'react';
import styles from './ChangePasswordPage.module.css';
import MainLayout from '../../layouts/MainLayout';
import apiClient from '../../api/apiClient';
import Banner from '../../components/Banner';

const ChangePasswordPage = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [banner, setBanner] = useState({
    open: false,
    message: '',
    severity: 'info',
  });
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setBanner({ open: false, message: '', severity: 'info' });

    if (newPassword.length < 8) {
      setBanner({
        open: true,
        message: 'New password must be at least 8 characters long',
        severity: 'error',
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      setBanner({
        open: true,
        message: 'New passwords do not match',
        severity: 'error',
      });
      return;
    }

    setLoading(true);

    try {
      const client = apiClient('iam');

      await client.put('/iam/change-password', {
        old_password: currentPassword,
        new_password: newPassword,
      });

      setBanner({
        open: true,
        message: 'Password changed successfully',
        severity: 'success',
      });
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      const detail = error.response?.data?.detail || 'Password change failed';
      setBanner({
        open: true,
        message: detail,
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className={styles.container}>
        <h2 className={styles.title}>Change Password</h2>
        <form onSubmit={handleChangePassword}>
          <div className={styles.formGroup}>
            <label>Current Password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label>Confirm New Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Changing...' : 'Change Password'}
          </button>
          {loading && <div className={styles.spinner}></div>}
        </form>
        <Banner
          open={banner.open}
          message={banner.message}
          severity={banner.severity}
          onClose={() => setBanner({ ...banner, open: false })}
        />
      </div>
    </MainLayout>
  );
};

export default ChangePasswordPage;
